import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api, errMsg, fromKSTInput } from "@/lib/api";

const inFiveDaysKST = () => new Date(Date.now() + (5 * 24 + 9) * 3600 * 1000).toISOString().slice(0, 16);

export const RestoreClaimDialog = ({ claim, onClose, onDone }) => {
  const [when, setWhen] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (claim) setWhen(inFiveDaysKST());
  }, [claim]);
  const save = async () => {
    if (!when) return toast.error("Pick a pay-by date");
    setBusy(true);
    try {
      await api.post("/admin/past-due/restore", { kind: claim.kind, claim_id: claim.id, pay_by: fromKSTInput(when) });
      toast.success("Claim restored");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={!!claim} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="restore-claim-dialog" className="bg-zinc-950 border-zinc-800 text-white">
        <DialogHeader>
          <DialogTitle>Restore {claim?.label}</DialogTitle>
          <DialogDescription className="text-zinc-400">The claim goes back to the joiner with no late fee. Late fees start again if it isn't paid by the new date.</DialogDescription>
        </DialogHeader>
        <label className="text-sm text-zinc-300">
          New pay-by date (KST)
          <input type="datetime-local" data-testid="restore-pay-by-input" value={when} onChange={(e) => setWhen(e.target.value)}
            className="mt-1.5 w-full rounded-lg border border-zinc-700 bg-zinc-900 px-3 py-2 text-sm text-white [color-scheme:dark]" />
        </label>
        <DialogFooter>
          <Button variant="ghost" data-testid="restore-cancel-btn" onClick={onClose}>Cancel</Button>
          <Button data-testid="restore-confirm-btn" disabled={busy} onClick={save}>{busy ? "Restoring…" : "Restore claim"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
